<template>
  <wz-card title="Firmantes">
    <p class="text-muted text-sm mb-3">
      Quién firma este documento y en qué orden. Para la empresa se elige un <strong>rol</strong>: la persona sale de
      quien ocupe ese rol en la empresa del colaborador. Un documento puede no tener firmantes.
    </p>

    <div v-for="(s, idx) in rows" :key="idx" class="flex flex-wrap items-end gap-2 mb-2 pb-2"
         style="border-bottom:1px solid var(--admin-border-color)">
      <div style="width: 70px;">
        <label class="wz-form-label">Orden</label>
        <div class="py-2 text-center"><strong>{{ idx + 1 }}</strong></div>
      </div>
      <div class="flex-1" style="min-width: 180px;">
        <label class="wz-form-label">Participante</label>
        <wz-select v-model="s.participant" :items="participantOptions" @change="onParticipant(s)" />
      </div>
      <div class="flex-1" style="min-width: 220px;">
        <label class="wz-form-label">Rol de la empresa</label>
        <wz-select v-model="s.signerRoleId" :items="roleOptions" defaultOption="Elegir rol"
                   :disabled="s.participant !== 'ROL_EMPRESA'" />
      </div>
      <div class="mb-2">
        <wz-checkbox v-model="s.isRequired" switch>Obligatorio</wz-checkbox>
      </div>
      <div class="mb-1 flex gap-1">
        <wz-button variant="light" size="sm" :disabled="idx === 0" @click="move(idx, -1)"><i class="ri-arrow-up-line"></i></wz-button>
        <wz-button variant="light" size="sm" :disabled="idx === rows.length - 1" @click="move(idx, 1)"><i class="ri-arrow-down-line"></i></wz-button>
        <wz-button variant="danger" size="sm" @click="rows.splice(idx, 1)"><i class="ri-delete-bin-line"></i></wz-button>
      </div>
    </div>

    <div class="flex justify-between mt-2">
      <wz-button variant="light" @click="add"><i class="ri-add-line mr-1"></i>Agregar firmante</wz-button>
      <wz-button variant="primary" @click="save">Guardar firmantes</wz-button>
    </div>
  </wz-card>
</template>

<script>
import { Alert } from '@wizepe/wizeui'
import { SignerService } from '@/core/services'

export default {
  name: 'DocumentSignersSection',
  props: {
    documentTypeId: { type: Number, required: true },
  },
  data() {
    return {
      rows: [],
      roles: [],
      participantOptions: [
        { key: 'COLABORADOR', label: 'Colaborador' },
        { key: 'ROL_EMPRESA', label: 'Rol de la empresa' },
        { key: 'TESTIGO', label: 'Testigo' },
      ],
    }
  },
  computed: {
    // Estándar y propios. Un rol propio solo lo puede ocupar alguien de su empresa: en las demás saldrá como hueco
    // en la cobertura de firmantes.
    roleOptions() {
      return this.roles.filter(r => r.status === 1)
        .map(r => ({ key: r.id, label: r.standard ? r.name : `${r.name} (propio de ${r.companyName})` }))
    },
  },
  async created() {
    try {
      const [signers, roles] = await Promise.all([
        SignerService.documentSigners(this.documentTypeId),
        SignerService.listRoles(null),
      ])
      this.roles = roles.payload || []
      this.rows = (signers.payload || []).map(s => ({
        participant: s.participant, signerRoleId: s.signerRoleId || null, isRequired: s.isRequired !== false,
      }))
    } catch (e) {
      Alert.error(e.errors ? e.errors.message : 'Error al cargar los firmantes')
    }
  },
  methods: {
    add() {
      this.rows.push({ participant: 'COLABORADOR', signerRoleId: null, isRequired: true })
    },
    move(idx, delta) {
      const target = idx + delta
      const [row] = this.rows.splice(idx, 1)
      this.rows.splice(target, 0, row)
    },
    onParticipant(s) {
      if (s.participant !== 'ROL_EMPRESA') s.signerRoleId = null
    },
    async save() {
      const list = this.rows.map((s, idx) => ({
        participant: s.participant,
        signerRoleId: s.participant === 'ROL_EMPRESA' ? s.signerRoleId : null,
        signOrder: idx + 1,
        isRequired: s.isRequired,
      }))
      try {
        await SignerService.replaceDocumentSigners(this.documentTypeId, list)
        Alert.success('Firmantes guardados')
      } catch (e) {
        Alert.error(e.errors ? e.errors.message : 'Error al guardar los firmantes')
      }
    },
  },
}
</script>
